import { apiClient } from "./client";

async function post(url, body) {
  const res = await apiClient.post(url, body);
  return res.data;
}

export const getCustomReportPresets = (id) => post("/dash/custom-reports/list", { id });
export const runCustomReport = (id, presetId, dateFrom, dateTo) =>
  post("/dash/custom-reports/run", { id, presetId, dateFrom, dateTo });
